import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { SwirlIllustrations } from '../../components';

import {
  FooterMenu,
  FooterSecondaryMenu,
} from '..';

import './style.scss';

const Footer = () => {
  return (
    <footer>
      <Container className="Footer-container">
        <FooterMenu />
        <FooterSecondaryMenu />
      </Container>
      <SwirlIllustrations variant="container" />
    </footer>
  );
};

export default Footer;
